export const useStyles = (theme) => ({
  root: {
    padding: 30,
    backgroundColor: "#f9f9fc",
    [theme.breakpoints.down("md")]: {
      marginLeft: "auto",
      marginRight: "auto",
      padding: 20,
    },
  },
  inputWithMargin: {
    width: "49%",
    marginRight: 10,
    [theme.breakpoints.down(960)]: {
      width: "100%",
    },
  },
  inputWithoutMargin: {
    width: "50%",
    [theme.breakpoints.down(960)]: {
      width: "100%",
    },
  },
  inputRoot: {
    height: 70,
  },
  labelRoot: {
    fontSize: 18,
    fontWeight: "bolder",
    backgroundColor: "#f9f9fb",
    paddingRight: 5,
  },
  notchedOutline: {},
  labelFocused: { color: "black !important" },
  focused: {
    "& $notchedOutline": {
      borderColor: "black !important",
    },
  },
  buttonStyle: {
    background: "#0a1f3a !important",
    outlineColor: "#0a1f3a !important",
    color: "#ffffff",
    fontSize: 18,
    borderRadius: 20,
    textTransform: "none",
    "&:hover": {
      backgroundColor: "#eee !important",
      borderColor: "#0a1f3a !important",
      color: "#181818",
    },
  },
  inputFieldStyle: {
    outline: "none",
    width: "32%",
    [theme.breakpoints.down("sm")]: {
      width: "100%",
    },
  },
  messageLoading: {
    fontSize: 25,
    fontWeight: "bold",
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
  },
  notificationStyle: {
    top: 80,
    right: 10,
  },
});
